// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createUserModalStyles } from "@guestsupply/Overrides/Widgets/UserList/CreateUserModal";
import Help from "@guestsupply/XDL/Icons/Help";
import { css } from "styled-components";

createUserModalStyles.container = { gap: 15 };

createUserModalStyles.modal = { sizeVariant: "large" };

createUserModalStyles.userNameVisibleGridItem = { width: [12, 12, 12, 6, 6] };

createUserModalStyles.userNameHiddenGridItem = {
    css: css`
        display: none;
    `,
};

createUserModalStyles.emailGridItem = { width: [12, 12, 12, 6, 6] };

createUserModalStyles.firstNameGridItem = { width: [12, 12, 12, 6, 6] };

createUserModalStyles.lastNameGridItem = { width: [12, 12, 12, 6, 6] };

createUserModalStyles.accountActivationHeadingGridItem = { width: 12 };

createUserModalStyles.accountActivationHeadingText = {
    variant: "h5",
    css: css`
        margin: 0;
    `,
};

createUserModalStyles.settingsHeadingGridItem = { width: 12 };

createUserModalStyles.settingsHeadingText = {
    variant: "h5",
    css: css`
        margin: 0;
    `,
};

createUserModalStyles.roleGridItem = { width: [12, 12, 12, 6, 6] };

createUserModalStyles.roleSelectWrapper = {
    css: css`
        display: flex;
        height: 15px;
    `,
};

createUserModalStyles.roleSelectHelpIcon = {
    src: Help,
    size: 13,
    color: "primary",
    css: css`
        margin-left: 5px;
        cursor: pointer;
        opacity: 0.33;
        &:hover {
            opacity: 1;
        }
    `,
};

createUserModalStyles.approverGridItem = { width: [12, 12, 12, 6, 6] };

createUserModalStyles.approverSelectTooltip = {
    cssOverrides: {
        tooltipClickable: css`
            vertical-align: top;
        `,
        
    },
    iconProps: {
        css: css`
            margin-left: 5px;
        `,
    },
};

createUserModalStyles.buttonsGridItem = {
    css: css`
        justify-content: flex-end;
    `,
    width: 12,
};

createUserModalStyles.cancelButton = { variant: "secondary" };

createUserModalStyles.submitButton = {
    css: css`
        margin-left: 1rem;
    `,
};

createUserModalStyles.approverSelect = {
    labelProps: {
        mergeCss: true,
        size: 12,
        transform: "capitalize",
        weight: 500,
        color: "text",
        css: css`
            min-height: initial;
            letter-spacing: 0;
            line-height: 13px;
            display: flex;
        `,
    },
};
